import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ScrollToTop  from '../pages/User/ScrollToTop'
import Home from '../pages/User/home'
import Singlecatgory from '../pages/User/Singlecatgory'
import Singleproducts from '../pages/User/singleproducts'
import Shop from '../pages/User/shop'
import Header from '../pages/header/header'
import Dashboard from '../pages/admin/Overview'
import Login from '../pages/auth/login'
import Signup from '../pages/auth/signup'
import Protectroute from './Protectroute'
import Footer from  '../pages/footer/footer'
import Cart from '../pages/User/cart'
import Wishlist from '../pages/User/Wishlist'
import CartDrawer  from '../pages/User/CartDrawer'
import Checkout  from '../pages/User/Checkout'
import Contact from '../pages/User/Contact'
import Myaccount from '../pages/User/AccountLayout'
import About from '../pages/User/about-us'
import { loadCart } from '../feature/cartSlice'
import AdminApp from '../pages/admin/AdminApp'
import AdminRoute from '../pages/admin/AdminRoute'
import Notfound from '../pages/User/NotFound'

function AppRoutes() {
    const dispatch = useDispatch()
    const { pathname } = useLocation()

    const isAdmin = /^\/admin(\/|$)/.test(pathname)

    useEffect(() => {
        dispatch(loadCart())
    }, [dispatch])

    return (
        <>
            <ScrollToTop />
            {!isAdmin && <Header />}
            {!isAdmin && <CartDrawer />}
            <Routes>
                {/* pages that need a login */}
                <Route element={<Protectroute />}>
                    {/* dynamic routing */}
                    {/* <Route path='admin-dashboard' element={<Dashboard />} /> */}
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/myaccount/*" element={<Myaccount />} />

                    {/* admin panel: only users whose role is 'admin' */}
                    <Route element={<AdminRoute />}>
                        <Route path="/admin/*" element={<AdminApp />} />
                    </Route>
                </Route>
                <Route path='/login' element={<Login />} />
                <Route path='/signup' element={<Signup />} />
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='product-category/:id' element={<Singlecatgory />} />
                <Route path='product/:id' element={<Singleproducts />} />
                <Route path='shop' element={<Shop />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="*" element={<Notfound />} />
            </Routes>
            {!isAdmin && <Footer />}
        </>
    )
}

export default AppRoutes
